module.exports = __webpack_public_path__ + "img/logo-white.a70710b7.png";